export const ENTRY_CHANNEL = {
  "002_11_0000_0000_00": "中信",
  "001_05_0054_0000_00": "深大",
  "004_02_0014_0002_01": "掌铁"
};
